import { RequestOptions, XHRBackend } from '@angular/http';
import { HttpService } from './http.service';

export function HttpServiceFactory(backend: XHRBackend, options: RequestOptions)
{
	return new HttpService(backend, options);
}

export let HttpServiceProvider =
	{
		provide: HttpService,
		useFactory: HttpServiceFactory,
		deps: [
			XHRBackend, RequestOptions
		]
	};



// WEBPACK FOOTER //
// ./src/app/http.service.provider.ts